/**
 * S2.4: Cegid ERP API Wrapper
 * Endpoints: Auth, Companies
 */

import { cegidFetch } from './auth';
import type { CegidCompany } from './types';

/**
 * Get all companies from Cegid ERP.
 * GET https://apierp.diezsoftware.com/api/Company/getCompanies
 */
export async function getCompanies(): Promise<CegidCompany[]> {
  const data = await cegidFetch('erp', '/api/Company/getCompanies');
  return Array.isArray(data) ? data : [];
}

/**
 * Get a specific company by code.
 */
export async function getCompanyByCode(code: string): Promise<CegidCompany | null> {
  const companies = await getCompanies();
  return companies.find(c => c.codigo === code) || null;
}
